import {WIKI_ITEM_PATH} from './../wiki.routing';
import {ChangeDetectionStrategy, Component, inject, Inject, input, output} from '@angular/core';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatIconModule} from '@angular/material/icon';
import {DatePipe, DOCUMENT} from '@angular/common';
import {CdkDrag, CdkDragHandle, CdkDragPlaceholder, CdkDragPreview} from '@angular/cdk/drag-drop';
import {WikiItem} from '../models/wiki.model';
import {MatButtonModule} from '@angular/material/button';
import {MessageService} from 'src/app/services/message.service';
import {MatTooltipModule} from '@angular/material/tooltip';

@Component({
  selector: 'wiki-item',
  standalone: true,
  imports: [
    MatIconModule,
    DatePipe,
    CdkDrag,
    CdkDragHandle,
    CdkDragPreview,
    CdkDragPlaceholder,
    ClipboardModule,
    MatButtonModule,
    MatTooltipModule,
  ],
  templateUrl: './wiki-item.component.html',
  styleUrl: './wiki-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WikiItemComponent {
  wikiItem = input<WikiItem>();
  onClick = output<WikiItem>();
  private messageService = inject(MessageService);

  constructor(@Inject(DOCUMENT) private document: Document) {}

  onEditWikiItem(): void {
    this.onClick.emit(this.wikiItem());
  }

  getWikiItemLink(): string {
    const {title, _id} = this.wikiItem();
    const domain = this.document.location.origin;
    const slug = title.replace(/\s+/g, '-').toLowerCase();
    return `${domain}/wiki/${WIKI_ITEM_PATH}/${slug}/${_id}`;
  }

  onCopyWikiItemLink(event: MouseEvent): void {
    event.stopPropagation();
    this.messageService.add(`Link copied to clipboard`, 'newTaskAssigned');
  }
}
